var _excluded = ["id", "children", "hasError", "isFluid", "value", "className", "size", "selectRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { string, bool, oneOf, node, oneOfType, func, shape, instanceOf, element } from 'prop-types';
import classNames from 'classnames';
import './Select.scss';
var propTypes = {
  /** Options inside the select. <br/>Use the option tag: `<option value="myValue">My Option</option>` */
  children: node.isRequired,

  /** The ID */
  id: string,

  /** Sets an option to be selected by default */
  value: string,

  /** Visual presentation of an error in the input */
  hasError: bool,

  /** Makes the select fill the parents available space */
  isFluid: bool,

  /** The size */
  size: oneOf(['small', 'medium', 'large']),

  /** Add your own custom class names to the component */
  className: string,

  /** Reference that can be used for setting focus to the component */
  selectRef: oneOfType([func, shape({
    current: instanceOf(element)
  })])
};
var defaultProps = {
  size: 'medium'
};
/** The Select lets users pick one option from a list of options. */

var Select = function Select(_ref) {
  var id = _ref.id,
      children = _ref.children,
      hasError = _ref.hasError,
      isFluid = _ref.isFluid,
      value = _ref.value,
      className = _ref.className,
      size = _ref.size,
      selectRef = _ref.selectRef,
      rest = _objectWithoutProperties(_ref, _excluded);

  var componentClassNames = classNames('rds-field rds-select', {
    'rds-select--danger': hasError,
    'rds-is-fluid': isFluid,
    'rds-select--small': size === 'small',
    'rds-select--medium': size === 'medium' || size === '' || size === null,
    'rds-select--large': size === 'large'
  }, className);
  return /*#__PURE__*/React.createElement("select", _extends({
    className: componentClassNames,
    id: id,
    value: value
  }, rest, {
    "aria-invalid": hasError,
    ref: selectRef
  }), children);
};

Select.propTypes = propTypes;
Select.defaultProps = defaultProps;
export default Select;